/**
 * Google Maps JavaScript API browser keys from Cloud Console are opaque strings
 * that typically start with `AIza` and are ~39 characters.
 */
export function isLikelyGoogleMapsJavaScriptApiKey(key: string): boolean {
  const t = key.trim();
  return t.startsWith("AIza") && t.length >= 35;
}
